import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, X, Search, Info } from 'lucide-react';
import { useHistory } from "react-router-dom";
import Tooltip from './Tooltip';
import { Routes } from '../../routes';
import apiHelper from '../../apiHelper';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal';
export default function AddDepartment() {
    const history = useHistory();
    const [disabled, setDisabled] = useState(false);
    const [validationError, setValidationError] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [departments, setDepartment] = useState([]);
    const supervisorRef = useRef(null);
    const [employeeData, setEmployeeData] = useState([]);
    const [parentSearch, setParentSearch] = useState("");
    const [selectedParent, setSelectedParent] = useState(null);
    const [isParentOpen, setIsParentOpen] = useState(false);

    const [formData, setFormData] = useState({
        department_name: '',
        short_name: '',
        status: '1',
        notes: '',
        parent_department: '',
        supervisor_id: ''
    });

    const [errors, setFormErrors] = useState({
        department_name: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        async function fetchData() {
            const response = await apiHelper('departments/list/');
            if (response && response.ok) {
                const result = await response.json();
                setDepartment(result);
            }

        }

        fetchData();
    }, []); // Empty dependency array ensures the effect runs only once

    const handleSave = async () => {

        setDisabled(true);
        let form_errors = { department_name: '' };
        let is_error = false;
        if (!formData.department_name) {
            form_errors["department_name"] = "This field is required!";
            is_error = true;
        }
        setFormErrors(form_errors);
        if (is_error) {
            setDisabled(false);
            setValidationError("Fail to be created");
            return false;
        }

        const response = await apiHelper('departments/create/', 'POST', formData);
        setDisabled(false);
        if (response) {
            if (response.ok) {
                setSuccessMessage('Department created successfully.');
                setValidationError([]);
                setFormData({
                    department_name: '',
                    short_name: '',
                    status: '1',
                    notes: '',
                    parent_department: '',
                    supervisor_id: ''
                });
                history.push('/department',{ success: "Department created successfully" })
            }
            else if (response.status == 400) { //for validation error
                const response_errors = await response.json();
                let errors = [];
                for (let i in response_errors) {
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setSuccessMessage('');
            }
        }


    };

    const [discardModalOpen, setDiscardModalOpen] = useState(false);
    const discardRef = useRef(null);
       const handleDiscard = () => {
        setDiscardModalOpen(true);
    };
    const handleDiscardConfirm = (confirm) => {
        if (confirm) {
            history.goBack();
        }
        setDiscardModalOpen(false);
    };
    const handleCancelDiscard = () => {
        setDiscardModalOpen(false);
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (discardRef.current && !discardRef.current.contains(event.target)) {
                setDiscardModalOpen(false);
            }
        }
        if (discardModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [discardModalOpen]);

    const [activeTab, setActiveTab] = useState("Add Departments");

    const breadcrumbs = [
        "Organisations",
        "Departments",
        activeTab
    ];

    const [supervisorSearch, setSupervisorSearch] = useState("");
    const [selectedSupervisor, setSelectedSupervisor] = useState(null);
    const [isSupervisorOpen, setIsSupervisorOpen] = useState(false);

    useEffect(() => {
        async function fetchEmployees() {
            try {
                const res = await apiHelper("users/list/");
                if (res.ok) {
                    const result = await res.json();
                    setEmployeeData(result);   
                }
            } catch (err) {
                console.error("Error fetching employees:", err);
            }
        }
        fetchEmployees();
    }, []);



    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Departments" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "Departments") {
                                        history.push(Routes.Department.path);
                                    }
                                }}
                                style={{ cursor: crumb === "Departments" ? "pointer" : "default" }}
                            >

                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                {validationError.length > 0 && (
                    <div
                        className="d-flex align-items-center justify-content-between"
                        role="alert"
                        style={{
                            boxShadow: "0px 4px 10px 0px #0000001F",
                            padding: "15px 10px",
                            borderRadius: "12px",
                            border: "1px solid #DC3545",   // red border
                            backgroundColor: "#F8D7DA",    // light red background
                            color: "#842029",              // dark red text
                            fontSize: "12px",
                            position: "fixed",
                            top: "10px",
                            width: "calc(100% - 20px)",
                            maxWidth: "640px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 2000,
                        }}
                    >
                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <X size={16} />
                            <strong>Fail to be created</strong>
                        </div>
                
                        <X
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => setValidationError([])}
                        />
                    </div>
                )}

                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Add Department</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button className="dark-button" type='button' onClick={handleDiscard}>Discard</button>
                        <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Department"  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
                        />
                        <button className="dark-border" type='button' onClick={handleSave} disabled={disabled}>Add Department</button>
                    </div>
                </div>

                <div className="info-section">
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Department Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="department_name" className="form-label">
                                                Department Name <span className='error-color'>*</span>
                                            </label>
                                            <input type="text" className={`form-control common-input-all  ${errors.department_name ? 'err-color' : ''}`} id="department_name" placeholder="Department Name" name="department_name" value={formData.department_name} onChange={handleChange} />
                                            {errors.department_name && <p style={{ color: 'red' }}>{errors.department_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="1" checked={formData.status === '1'} name="status" onChange={handleChange} id="flexRadioDefault1" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                        Active
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="0" checked={formData.status === '0'} name="status" onChange={handleChange} id="flexRadioDefault2" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                        Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="id" className="form-label d-flex align-items-center gap-2">
                                                Short Name
                                                <Tooltip title="Short Name" body="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className='form-control common-input-all'
                                                id="id"
                                                placeholder="Short Name"
                                                name="short_name"
                                                onChange={handleChange}
                                                value={formData.short_name}
                                            />

                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" style={{ position: "relative" }}>
                                            <label htmlFor="parentdepartment" className="form-label d-flex align-items-center gap-1">
                                                Parent Department
                                                <Tooltip title="Parent Department" body="The parent department of this department">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>

                                            <div
                                                className="select-box form-control common-input-all"
                                                onClick={() => setIsParentOpen(!isParentOpen)}
                                                style={{
                                                    padding: "0.5rem",
                                                    minHeight: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {selectedParent ? (
                                                    <span
                                                        className="tag"
                                                        style={{
                                                            backgroundColor: "#FFEB00",
                                                            borderRadius: "16px",
                                                            padding: "4px 8px",
                                                            fontSize: "12px"
                                                        }}
                                                    >
                                                        {selectedParent.department_name}
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedParent(null);
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    parent_department: ''
                                                                }));
                                                            }}
                                                            style={{ background: "none", border: "none", marginLeft: "8px", cursor: "pointer" }}
                                                        >
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span>
                                                ) : (
                                                    <span style={{ color: "#999" }}>Select Parent Department</span>
                                                )}
                                                <ChevronDown size={16} style={{ marginLeft: "auto" }} />
                                            </div>

                                            {isParentOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: "1px solid #6c757d",
                                                        borderRadius: "8px",
                                                        marginTop: "4px",
                                                        maxHeight: "270px",
                                                        overflowY: "auto",
                                                        background: "#fff",
                                                        position: "absolute",
                                                        top: "100%",
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {/* Search box */}
                                                    <div style={{ padding: "0.5rem", position: "relative" }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: "absolute",
                                                                top: "50%",
                                                                left: "18px",
                                                                transform: "translateY(-50%)",
                                                                color: "#6C757D",
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="Search..."
                                                            className="form-control"
                                                            style={{ paddingLeft: "2rem" }}
                                                            value={parentSearch}
                                                            onChange={(e) => setParentSearch(e.target.value)}
                                                        />
                                                    </div>

                                                    {/* List */}
                                                    <ul style={{ listStyle: "none", padding: "0.5rem" }}>
                                                        {departments
                                                            .filter((dep) =>
                                                                dep.department_name.toLowerCase().includes(parentSearch.toLowerCase())
                                                            )
                                                            .map((dep) => (
                                                                <li
                                                                    key={dep.department_id}
                                                                    style={{ padding: "4px 8px", cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        setSelectedParent(dep);
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            parent_department: dep.department_id, // 👈 backend expects ID
                                                                        }));
                                                                        setIsParentOpen(false);
                                                                    }}
                                                                >
                                                                    {dep.department_name}
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={supervisorRef} style={{ position: "relative" }}>
                                            <label className="form-label d-flex align-items-center gap-1">
                                                Supervisor
                                                <Tooltip title="Supervisor" body="Select a Supervisor">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div
                                                className="select-box form-control common-input-all"
                                                onClick={() => setIsSupervisorOpen(!isSupervisorOpen)}
                                                style={{
                                                    padding: "0.5rem",
                                                    minHeight: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {selectedSupervisor ? (
                                                    <span className="tag" style={{ backgroundColor: "#FFEB00", borderRadius: "16px", padding: "4px 8px", fontSize: "12px" }}>
                                                        {selectedSupervisor.employee_first_name} {selectedSupervisor.employee_last_name}

                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedSupervisor(null);
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    supervisor_id: '',     // reset backend field too
                                                                }));
                                                            }}
                                                            style={{ background: "none", border: "none", marginLeft: "8px", cursor: "pointer" }}
                                                        >
                                                            <X size={14} strokeWidth={3} />
                                                        </button>

                                                    </span>
                                                ) : (
                                                    <span style={{ color: "#999" }}>Select Supervisor</span>
                                                )}
                                                <ChevronDown size={16} style={{ marginLeft: "auto" }} />
                                            </div>

                                            {isSupervisorOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: "1px solid #6c757d",
                                                        borderRadius: "8px",
                                                        marginTop: "4px",
                                                        maxHeight: "270px",
                                                        overflowY: "auto",
                                                        background: "#fff",
                                                        position: "absolute",
                                                        top: "100%",
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {/* Search box */}
                                                    <div style={{ padding: "0.5rem", position: "relative" }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: "absolute",
                                                                top: "50%",
                                                                left: "18px",
                                                                transform: "translateY(-50%)",
                                                                color: "#6C757D",
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="Search..."
                                                            className="form-control"
                                                            style={{ paddingLeft: "2rem" }}
                                                            value={supervisorSearch}
                                                            onChange={(e) => setSupervisorSearch(e.target.value)}
                                                        />
                                                    </div>

                                                    {/* List */}
                                                    <ul style={{ listStyle: "none", padding: "0.5rem" }}>
                                                        {employeeData
                                                            .filter((emp) =>
                                                                `${emp.employee_first_name} ${emp.employee_last_name}`
                                                                    .toLowerCase()
                                                                    .includes(supervisorSearch.toLowerCase())
                                                            )
                                                            .map((emp) => (                                                                <li
                                                                    key={emp.id}
                                                                    style={{ padding: "4px 8px", cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        setSelectedSupervisor(emp); // keep for UI
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            supervisor_id: emp.id      // 👈 update backend payload
                                                                        }));
                                                                        setIsSupervisorOpen(false);
                                                                    }}
                                                                >
                                                                    {emp.employee_first_name} {emp.employee_last_name}
                                                                </li>

                                                            ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Note</label>
                                <textarea className="form-control w-100 common-textarea-all" name="notes" value={formData.notes} onChange={handleChange} id="exampleFormControlTextarea1" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                {/* {discardModalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={discardRef}
                            style={{
                                maxWidth: 650,
                                margin: "0 auto",
                                background: "white",
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                height: "auto",
                                right: "auto",
                                overflow: "inherit",
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setDiscardModalOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Are you sure?</h3>
                            <div className="drawer-footer" style={{ paddingTop: "10px", display: "flex", gap: "10px" }}>
                                <button className="btn-save" onClick={() => handleDiscardConfirm(true)}>
                                    Yes
                                </button>
                                <button className="btn-cancel" onClick={() => handleDiscardConfirm(false)}>
                                    No
                                </button>
                            </div>
                        </div>
                    </>
                )} */}
            </div>
        </>
    );
}